document.addEventListener("DOMContentLoaded", function () {
  const headerSpans = document.querySelectorAll(
    ".accordion-item .accordion-header span"
  );

  const selectField = document.querySelector('select[name="job"]');

  headerSpans.forEach((span) => {
    const option = document.createElement("option");
    option.text = span.textContent;
    selectField.add(option);
  });

  const buttons = document.querySelectorAll(".wp-block-button__link");

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      const parentAccordionItem = button.closest(".accordion-item");

      const jobText = parentAccordionItem.querySelector(
        ".accordion-header span"
      ).textContent;

      selectField.value = jobText;

      const formElement = document.querySelector("form");
      formElement.scrollIntoView({ behavior: "smooth" });
    });
  });
});
